import React, { useCallback } from 'react';
import useVideoStore from './stores/useVideoStore';
import { useTranslations } from '../ArticleFormNew/contexts/TranslationContext';

export default function ShortDescriptionFields({ scheduleAutosave }) {
  var t = useTranslations();
  var shortDescId = useVideoStore(function(s) { return s.short_description_id; });
  var shortDescEn = useVideoStore(function(s) { return s.short_description_en; });
  var updateField = useVideoStore(function(s) { return s.updateField; });

  var handleIdChange = useCallback(function(e) {
    updateField('short_description_id', e.target.value);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  var handleEnChange = useCallback(function(e) {
    updateField('short_description_en', e.target.value);
    scheduleAutosave();
  }, [updateField, scheduleAutosave]);

  return (
    <div className="mb-3">
      <div className="mb-2">
        <label className="form-label small text-muted mb-1">{t.short_description_id_label}</label>
        <div className="form-group">
          <textarea
            className="form-control"
            rows="4"
            placeholder={t.short_description_placeholder}
            value={shortDescId || ''}
            onChange={handleIdChange}
          />
          <i className="form-group__bar" />
        </div>
      </div>
      <div>
        <label className="form-label small text-muted mb-1">{t.short_description_en_label}</label>
        <div className="form-group">
          <textarea
            className="form-control"
            rows="4"
            placeholder={t.short_description_placeholder}
            value={shortDescEn || ''}
            onChange={handleEnChange}
          />
          <i className="form-group__bar" />
        </div>
      </div>
    </div>
  );
}
